import React, { useContext } from 'react';
import { View, Platform } from 'react-native';
import { Components } from '@oneamerica/dxp-ui-components';
import { isSessionActive } from './AuthHelpers';
import { AuthContext } from './AuthProvider';

const withAuth = (Component, redirect = true) => {
  const WithAuth = (props) => {
    const {
      accessToken,
      authClient,
      authLogin,
      authLogout,
      idToken,
      initialState,
      isAuthenticated,
      refreshAuthSession,
      refreshAuthToken,
      session,
      user,
    } = useContext(AuthContext);

    const checkLocalStorage = async () => {
      if (!isSessionActive(session)) {
        if (Platform.OS === 'web') {
          // @ts-ignore
          window.localStorage.removeItem('isBannerHidden');
        }
      }
    };

    if (!isAuthenticated && redirect) {
      if (!authClient.isLoginRedirect()) {
        authLogin();
        checkLocalStorage();
      }
      //return view for unauthenticated user
      return (
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <Components.LoadingIndicator />
        </View>
      );
    }

    return (
      <Component
        {...props}
        // authClient={authClient}
        accessToken={accessToken}
        authLogin={authLogin}
        authLogout={authLogout}
        idToken={idToken}
        initialState={initialState}
        isAuthenticated={isAuthenticated}
        refreshAuthSession={refreshAuthSession}
        refreshAuthToken={refreshAuthToken}
        session={session}
        user={user}
      />
    );
  };

  return WithAuth;
};

export default withAuth;
